import { machineTypeSchema } from "@packsize/schemas/machines";

export const X4_MACHINES_QUERY_KEY = ["machines", { machineType: machineTypeSchema.enum.X4 }] as const;
